<template>
  <table class="table table-striped ">
    <tbody>
    <tr v-for="(list ,index) in lists" key="index">

      <td colspan="2">
        <img src="@/agent/assets/images/logo.png" style="width: 25px"> {{ list.title }}
      </td>
      <td>
        {{
          number.numberFormats((type === 'credit') ? Credit(list.price, list.buyCredit) : (type === 'payment') ? online(list.price, list.git_online) : list.price)
        }}
        تومان
      </td>

      <td><i class="fa fa-trash" @click="removeItme(list.id , list.price)" v-if="check.checkMethod !== true "></i></td>

    </tr>

    </tbody>
    <tfoot>
    <tr>
      <td colspan="4" style="text-align: end">
        <button class="btn btn-outline-dark ">
          جمع کل
          <span>{{
              number.numberFormats((type === 'credit') ? buyCreditTotal : (type === 'payment') ? git_onlineTotal : total)
            }}</span>
          تومان
        </button>
      </td>
    </tr>
    </tfoot>
  </table>
</template>
<script setup>
import * as number from "@/common/helpers/Number";
import {useStore} from 'vuex'
import {computed} from "vue";

const type = computed(() => {
  return store.state.statusType;
})

const check = defineProps({
  checkMethod: ""
})

const store = useStore()
let buyCreditTotal = 0
let buyCredits = 0
let git_online = 0
let git_onlineTotal = 0

const lists = computed(() => {
  return store.state.listCard
})


const statusType = computed(() => {
  return store.state.statusType;
})

function Credit(price, discountPercentage) {
  if (discountPercentage) {
    if (price) {
      let percentageAmount = (price * discountPercentage) / 100;
      buyCredits = parseInt(price) - parseInt(percentageAmount);
      buyCreditTotal += parseInt(price) - parseInt(percentageAmount);
      return buyCredits;
    }
  }
}

function online(price, discountPercentage) {
  if (discountPercentage) {
    if (price) {
      let percentageAmount = (price * discountPercentage) / 100;
      git_online = parseInt(price) - parseInt(percentageAmount);
      git_onlineTotal += parseInt(price) - parseInt(percentageAmount);
      return git_online;
    }
  }
}

const total = computed(() => {
  return store.state.total;
})

function removeItme(id, price) {
  store.dispatch('removeCart', {id: id, 'price': price});
}
</script>